import {
	ContentRecommendation,
	EmptyLoadingElement,
} from '@/components/content/ContentRecommendation';

const emsName = 'DPCatalogFooterCopyright';

export const CopyrightDesktop = () => (
	<ContentRecommendation
		id={`footer-${emsName}`}
		properties={{ emsName }}
		loadingElement={<EmptyLoadingElement />}
	/>
);
